export const removeDuplicateItems = (customerArray, key) => [
  ...new Map(customerArray.map((x) => [key(x), x])).values(),
];

export const GetColor = (index) => {
  let text = "#3699B8";
  switch (index) {
    case 0:
      text = "#545456";
      break;
    case 1:
      text = "#c20001";
      break;
    case 2:
      text = "#ce5b00";
      break;
    case 3:
      text = "#0271b8";
      break;
    case 4:
      text = "#118b02";
      break;
    case 5:
      text = "#545456";
      break;
    case 6:
      text = "#FF9666";
      break;
    case 7:
      text = "#FFBE6E";
      break;
    case 8:
      text = "#606B6D";
      break;
    case 9:
      text = "#2AFFD4";
      break;
    case 10:
      text = "#F2C90D";
      break;
    case 11:
      text = "#FF6261";
      break;
    case 12:
      text = "#374649";
      break;
    case 13:
      text = "#2AFF7F";
      break;
    default:
      text = "#3699B8";
      break;
  }
  return text;
};

export const keyRestrict12 = (
  e,
  validchars,
  casesensitives,
  onceevery,
  onceoneof
) => {
  onceevery = onceevery || "";
  onceoneof = onceoneof || "";
  if (!validchars) return true;
  let key = "";
  let keychar = "";
  let i = 0;
  if (window.event) key = window.event.keyCode; // IE
  else key = e.which;

  const obj = e.target ? e.target : window.event.srcElement;
  if (key == null) return true;
  keychar = String.fromCharCode(key);
  validchars = validchars + onceevery + onceoneof;
  if (!casesensitives) {
    keychar = keychar.toLowerCase();
    validchars = validchars.toLowerCase();
    onceevery = onceevery.toLowerCase();
    onceoneof = onceoneof.toLowerCase();
  }
  for (i = 0; i < (onceevery + onceoneof).length; i++) {
    if (i < onceevery.length) {
      if (
        obj.value.indexOf(onceevery.charAt(i)) !== -1 &&
        keychar === onceevery.charAt(i)
      )
        return false;
    } else if (
      obj.value.indexOf(onceoneof.charAt(i - onceevery.length)) !== -1 &&
      onceoneof.indexOf(keychar) !== -1
    )
      return false;
  }
  if (validchars.indexOf(keychar) !== -1) return true;

  if (key == null || key === 0 || key === 8 || key === 9 || key === 27)
    // key==13 ||
    return true;
  e.preventDefault();
  return false;
};

export const keyRestrict = (
  e,
  validChars = "",
  caseSensitive = false,
  onceEvery = "",
  onceOneOf = ""
) => {
  const { key } = e;
  const input = e.target.value;

  if (!caseSensitive) {
    validChars = validChars.toLowerCase();
    onceEvery = onceEvery.toLowerCase();
    onceOneOf = onceOneOf.toLowerCase();
  }

  const keyChar = caseSensitive ? key : key.toLowerCase();
  const allValidChars = validChars + onceEvery + onceOneOf;

  // Allow special control keys (Backspace, Tab, Escape, etc.)
  if (
    [
      "Backspace",
      "Tab",
      "Escape",
      "Enter",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
    ].includes(key)
  ) {
    return true;
  }

  // Disallow if keyChar is not in allowed characters
  if (!allValidChars.includes(keyChar)) {
    e.preventDefault();
    return false;
  }

  // Enforce onceEvery rule
  for (const char of onceEvery) {
    if (input.includes(char) && keyChar === char) {
      e.preventDefault();
      return false;
    }
  }

  // Enforce onceOneOf rule (only one of the group allowed once)
  for (const char of onceOneOf) {
    if (input.includes(char) && onceOneOf.includes(keyChar)) {
      e.preventDefault();
      return false;
    }
  }

  return true;
};

export const ClearSessionStorage = () => {
  sessionStorage.setItem("USER", "");
  sessionStorage.setItem("firstNmae", "");
  sessionStorage.setItem("lastName", "");
  sessionStorage.setItem("userUUID", "");
  sessionStorage.setItem("isTrainer", "");
  sessionStorage.setItem("type", "");
  sessionStorage.setItem("fullAccess", "");
  sessionStorage.setItem("PAGENAME", "");
  sessionStorage.setItem("islocked", "");
  sessionStorage.setItem("CP", "");
  sessionStorage.setItem("Reseller", "");
  sessionStorage.setItem("team_seq_num", "");
  sessionStorage.setItem("show_support", "");
  sessionStorage.setItem("show_implementation", "");
  sessionStorage.setItem("ANT", "");
  sessionStorage.setItem("ANT_SEQ_NUM", "");
  sessionStorage.setItem("CNT", "");
  sessionStorage.setItem("CNT_SEQ_NUM", "");
  sessionStorage.setItem("TNT", "");
  sessionStorage.setItem("TNT_SEQ_NUM", "");
  sessionStorage.setItem("S", "");
  sessionStorage.setItem("S_SEQ_NUM", "");
};

const BASE_SUPPORT_URL = process.env.REACT_APP_BASE_SUPPORT_URL;
const BASE_AUTH_URL = process.env.REACT_APP_BASE_AUTH_URL;
const BASE_PATIENT_URL = process.env.REACT_APP_BASE_PATIENT_URL;

const getBaseUrl = (type) => {
  switch (type) {
    case "auth":
      return BASE_AUTH_URL;
    case "PEHR":
      return BASE_PATIENT_URL;
    default:
      return BASE_SUPPORT_URL;
  }
};

export async function FetchData(endpoint, type, queryParams, APIKey = null) {
  const base = getBaseUrl(type);

  const url = `${base}v1/${endpoint}${queryParams ? `?${queryParams}` : ""}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("userToken")}`,
      APIKey,
    },
  });
  const json = await response.json();

  return json;
}

export async function PostData(endpoint, data, type, APIKey = null) {
  const base = getBaseUrl(type);

  const url = `${base}v1/${endpoint}`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("userToken")}`,
      APIKey,
    },
    body: JSON.stringify(data),
  });
  const json = await response.json();
  return json;
}

export async function DeleteData(endpoint, type, queryParams, APIKey = null) {
  const base = getBaseUrl(type);

  const url = `${base}v1/${endpoint}${queryParams ? `?${queryParams}` : ""}`;

  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("userToken")}`, // Use environment variable
      APIKey,
    },
  });
  const json = await response.json();
  return json;
}

export async function UpdateData(
  endpoint,
  data,
  type,
  queryParams,
  APIKey = null,
  methodValue = null
) {
  const base = getBaseUrl(type);

  const url = `${base}v1/${endpoint}${queryParams ? `?${queryParams}` : ""}`;

  const response = await fetch(url, {
    method: methodValue == null ? "PUT" : methodValue,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("userToken")}`,
      APIKey,
    },
    body: JSON.stringify(data),
  });
  const json = await response.json();

  return json;
}
